// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file ai/h2o/cloud/telemetry_read_api/v1/aiunits.proto (package ai.h2o.cloud.telemetry_read_api.v1, syntax proto3)
/* eslint-disable */

import type { BigIntString } from "../../../../../runtime";
import { RPC } from "../../../../../runtime";
import type { Interval } from "../../../../../google/type/interval_pb";

/**
 * @generated from enum ai.h2o.cloud.telemetry_read_api.v1.Granularity
 */
export enum Granularity {
/**
 * @generated from enum value: GRANULARITY_UNSPECIFIED = 0;
 */
GRANULARITY_UNSPECIFIED = "GRANULARITY_UNSPECIFIED",

/**
 * @generated from enum value: YEAR = 1;
 */
YEAR = "YEAR",

/**
 * @generated from enum value: MONTH = 2;
 */
MONTH = "MONTH",

/**
 * @generated from enum value: WEEK = 3;
 */
WEEK = "WEEK",

/**
 * @generated from enum value: DAY = 4;
 */
DAY = "DAY",

/**
 * @generated from enum value: HOUR = 5;
 */
HOUR = "HOUR",
}
/**
 * @generated from enum ai.h2o.cloud.telemetry_read_api.v1.Grouping
 */
export enum Grouping {
/**
 * ie, total
 *
 * @generated from enum value: GROUPING_UNSPECIFIED = 0;
 */
GROUPING_UNSPECIFIED = "GROUPING_UNSPECIFIED",

/**
 * @generated from enum value: WORKSPACE = 1;
 */
WORKSPACE = "WORKSPACE",

/**
 * @generated from enum value: USER = 2;
 */
USER = "USER",

/**
 * aka resource_server
 *
 * @generated from enum value: SERVICE = 3;
 */
SERVICE = "SERVICE",

/**
 * @generated from enum value: TAG = 4;
 */
TAG = "TAG",
}
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.ListComponentsRequest
 */
export type ListComponentsRequest = {
/**
 * The maximum number of components to return. The service may return fewer than
 * this value.
 * If unspecified, at most 50 component will be returned.
 * The maximum value is 1000; values above 1000 will be coerced to 1000.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * A page token, received from a previous `ListComponents` call.
 * Provide this to retrieve the subsequent page.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.ListComponentsResponse
 */
export type ListComponentsResponse = {
/**
 * The components set.
 *
 * @generated from field: repeated ai.h2o.cloud.telemetry_read_api.v1.Component components = 1;
 */
components?: Component[];
/**
 * A token, which can be sent as `page_token` to retrieve the next page.
 * If this field is omitted, there are no subsequent pages.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.Component
 */
export type Component = {
/**
 * Format: components/{component}
 * The name of a component.
 *
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.ListServicesRequest
 */
export type ListServicesRequest = {
/**
 * The maximum number of services to return. The service may return fewer than
 * this value.
 * If unspecified, at most 50 services will be returned.
 * The maximum value is 1000; values above 1000 will be coerced to 1000.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * A page token, received from a previous `ListServices` call.
 * Provide this to retrieve the subsequent page.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.ListServicesResponse
 */
export type ListServicesResponse = {
/**
 * The list of distinct service names from the telemetry table.
 * These values can be used in the service filter for CalculateResourceUsageRequest.
 *
 * @generated from field: repeated string services = 1;
 */
services?: string[];
/**
 * A token, which can be sent as `page_token` to retrieve the next page.
 * If this field is omitted, there are no subsequent pages.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Format: components/{component}:calculateUsage
 *
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.CalculateUsageRequest
 */
export type CalculateUsageRequest = {
/**
 * The start of interval of a time for which the usage is calculated.
 *
 * @generated from field: google.protobuf.Timestamp start_time = 1;
 */
startTime: string;
/**
 * The end of interval of a time for which the usage is calculated.
 *
 * @generated from field: google.protobuf.Timestamp end_time = 2;
 */
endTime: string;
/**
 * The granularity of the usage calculation, limited to difference between From and To field values of the request's interval.
 * Examples:
 * Request of the usage between 1.01.2022 and 1.01.2023 would return:
 * - 1 year in case when granularity is set to YEAR
 * - 12 months in case when granularity is set to MONTH
 * - 52 weeks in case when granularity is set to WEEK
 * Though request of the usage between 6.00 and 10.00 of a given day with the granularity set to DAY,
 * will return 4 hours (downgrading the granularity to HOUR), as there's not enough data to calculate a whole day.
 *
 * @generated from field: ai.h2o.cloud.telemetry_read_api.v1.Granularity granularity = 3;
 */
granularity: Granularity;
/**
 * A component of which the usage is calculated. Example: components/global:calculateUsage
 *
 * @generated from field: string component = 4;
 */
component: string;
/**
 * The maximum number of usage data points to return. The service may return fewer than
 * this value.
 * If unspecified, at most 50 usage data points will be returned.
 * The maximum value is 1000; values above 1000 will be coerced to 1000.
 *
 * @generated from field: int32 page_size = 5;
 */
pageSize?: number;
/**
 * A page token, received from a previous `CalculateUsage` call.
 * Provide this to retrieve the subsequent page.
 *
 * @generated from field: string page_token = 6;
 */
pageToken?: string;
/**
 * [AIP-160]: https://google.aip.dev/160 filter for the request.
 * Example: payload.assignments.creator_name="h2o functions user"
 *
 * @generated from field: string filter = 7;
 */
filter?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.CalculateUsageResponse
 */
export type CalculateUsageResponse = {
/**
 * The usage time series.
 *
 * @generated from field: repeated ai.h2o.cloud.telemetry_read_api.v1.Usage usage = 1;
 */
usage?: Usage[];
/**
 * A token, which can be sent as `page_token` to retrieve the next page.
 * If this field is omitted, there are no subsequent pages.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.Usage
 */
export type Usage = {
/**
 * The milli AI Units amount.
 *
 * @generated from field: int64 milli_ai_units = 1;
 */
milliAiUnits?: BigIntString;
/**
 * The interval where AI Units were used.
 *
 * @generated from field: google.type.Interval interval = 2;
 */
interval?: Interval;
}
;
/**
 * Format: components/{component}:calculateMaxUsage
 *
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.CalculateMaxUsageRequest
 */
export type CalculateMaxUsageRequest = {
/**
 * The component of which the usage is calculated. Example: components/global:calculateMaxUsage
 *
 * @generated from field: string component = 1;
 */
component: string;
/**
 * The start of the interval of a time for which the max usage is calculated. Optional.
 * If not provided, max usage will be calculated only with respect to `to` field value.
 *
 * @generated from field: google.protobuf.Timestamp start_time = 2;
 */
startTime?: string | null;
/**
 * The end of the interval of a time for which the max usage is calculated. Optional.
 * If not provided, max usage will be calculated only with respect to `from` field value.
 *
 * @generated from field: google.protobuf.Timestamp end_time = 3;
 */
endTime?: string | null;
/**
 * [AIP-160]: https://google.aip.dev/160 filter for the request.
 * Example: payload.assignments.creator_name="h2o functions user"
 *
 * @generated from field: string filter = 7;
 */
filter?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.MaxUsage
 */
export type MaxUsage = {
/**
 * The milli AI Units amount.
 *
 * @generated from field: int64 milli_ai_units = 1;
 */
milliAiUnits?: BigIntString;
/**
 * The timestamp where max usage occurred.
 *
 * @generated from field: google.protobuf.Timestamp timestamp = 2;
 */
timestamp?: string | null;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.CalculateMaxUsageResponse
 */
export type CalculateMaxUsageResponse = {
/**
 * The max usage including relevant timestamp.
 *
 * @generated from field: ai.h2o.cloud.telemetry_read_api.v1.MaxUsage max_usage = 1;
 */
maxUsage?: MaxUsage;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.GetQuotaRequest
 */
export type GetQuotaRequest = {
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.GetQuotaResponse
 */
export type GetQuotaResponse = {
/**
 * Current quota.
 *
 * @generated from field: ai.h2o.cloud.telemetry_read_api.v1.Quota quota = 1;
 */
quota?: Quota;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.Quota
 */
export type Quota = {
/**
 * Milli AI Units.
 *
 * @generated from field: int64 milli_ai_units = 1;
 */
milliAiUnits?: BigIntString;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.CalculateResourceUsageRequest
 */
export type CalculateResourceUsageRequest = {
/**
 * The start time of interval which the usage is calculated.
 *
 * @generated from field: google.protobuf.Timestamp start_time = 1;
 */
startTime: string;
/**
 * The end time of interval which the usage is calculated.
 *
 * @generated from field: google.protobuf.Timestamp end_time = 2;
 */
endTime: string;
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.v1.Granularity granularity = 3;
 */
granularity: Granularity;
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.v1.Grouping group_by = 4;
 */
groupBy: Grouping;
/**
 * When used, server will only calculate resource usage of resources that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160) specification.
 *
 * Supported fields:
 *   * workspace
 *   * user
 *   * tag
 *   * service
 *
 * Examples:
 * workspace = 'my_workspace' AND user = 'test_user'
 * (workspace = 'my_workspace_1' OR workspace = 'my_workspace_2') AND user = 'test_user'
 *
 * @generated from field: string filter = 5;
 */
filter?: string;
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return less items then specified.
 *
 * @generated from field: int32 page_size = 6;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 7;
 */
pageToken?: string;
/**
 * When used, server will return usage_breakdown for each interval ordered by the specified field.
 * Only one field will be supported once. No secondary ordering is supported.
 * Supported fields are cpu, memory, gpu, ai_units.
 * Default ordering will be in descending order for any field. i.e "cpu" == "cpu DESC"
 * Default will be "ai_units DESC" if not set.
 * Ex: "cpu ASC", "memory DESC"
 *
 * @generated from field: string order_by = 8;
 */
orderBy?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.CalculateResourceUsageResponse
 */
export type CalculateResourceUsageResponse = {
/**
 * @generated from field: repeated ai.h2o.cloud.telemetry_read_api.v1.ResourceUsageWithBreakdown usage = 1;
 */
usage?: ResourceUsageWithBreakdown[];
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.v1.Grouping grouped_by = 2;
 */
groupedBy?: Grouping;
/**
 * @generated from field: string next_page_token = 3;
 */
nextPageToken?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.ResourceUsageWithBreakdown
 */
export type ResourceUsageWithBreakdown = {
/**
 * @generated from field: google.type.Interval interval = 1;
 */
interval?: Interval;
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.v1.ResourceUsage total_usage = 2;
 */
totalUsage?: ResourceUsage;
/**
 * @generated from field: repeated ai.h2o.cloud.telemetry_read_api.v1.ResourceUsageBreakdown usage_breakdown = 3;
 */
usageBreakdown?: ResourceUsageBreakdown[];
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.ResourceUsageBreakdown
 */
export type ResourceUsageBreakdown = {
/**
 * @generated from field: string group = 1;
 */
group?: string;
/**
 * @generated from field: ai.h2o.cloud.telemetry_read_api.v1.ResourceUsage usage = 2;
 */
usage?: ResourceUsage;
}
;
/**
 * @generated from message ai.h2o.cloud.telemetry_read_api.v1.ResourceUsage
 */
export type ResourceUsage = {
/**
 * @generated from field: int64 milli_cpu = 1;
 */
milliCpu?: BigIntString;
/**
 * @generated from field: int64 memory_bytes = 2;
 */
memoryBytes?: BigIntString;
/**
 * @generated from field: int64 gpu_count = 3;
 */
gpuCount?: BigIntString;
/**
 * @generated from field: int64 milli_ai_units = 4;
 */
milliAiUnits?: BigIntString;
}
;
/**
 * Lists the components which can be an input for UsageService.CalculateUsage API.
 *
 * @generated from rpc ai.h2o.cloud.telemetry_read_api.v1.ComponentService.ListComponents
 */
export const ComponentService_ListComponents = new RPC<ListComponentsRequest,ListComponentsResponse>("GET", "/v1/components");
/**
 * Lists the services which can be an input for UsageService.CalculateResourceUsage API service filter.
 *
 * @generated from rpc ai.h2o.cloud.telemetry_read_api.v1.ServiceService.ListServices
 */
export const ServiceService_ListServices = new RPC<ListServicesRequest,ListServicesResponse>("GET", "/v1/services");
/**
 * @generated from rpc ai.h2o.cloud.telemetry_read_api.v1.UsageService.CalculateUsage
 */
export const UsageService_CalculateUsage = new RPC<CalculateUsageRequest,CalculateUsageResponse>("GET", "/v1/{component=components/*}:calculateUsage");
/**
 * @generated from rpc ai.h2o.cloud.telemetry_read_api.v1.UsageService.CalculateMaxUsage
 */
export const UsageService_CalculateMaxUsage = new RPC<CalculateMaxUsageRequest,CalculateMaxUsageResponse>("GET", "/v1/{component=components/*}:calculateMaxUsage");
/**
 * @generated from rpc ai.h2o.cloud.telemetry_read_api.v1.UsageService.CalculateResourceUsage
 */
export const UsageService_CalculateResourceUsage = new RPC<CalculateResourceUsageRequest,CalculateResourceUsageResponse>("GET", "/v1/resourceUsage:calculate");
/**
 * @generated from rpc ai.h2o.cloud.telemetry_read_api.v1.QuotaService.GetQuota
 */
export const QuotaService_GetQuota = new RPC<GetQuotaRequest,GetQuotaResponse>("GET", "/v1/quota");
